// LoginModal.jsx
import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FiEye, FiEyeOff } from "react-icons/fi";
import map from "../assets/map.png"; // replace with your actual image path
import { FiX } from "react-icons/fi"
import img from "../assets/OTP.png";
import OTPInputScreen from "./OTPInputScreen";
import { FiEdit3 } from "react-icons/fi";

const LoginModal = ({ show, handleClose }) => {
  const [active, setActive] = useState("SIGNIN");
  const [showotp,setShopOTP] =useState(false)
  const [mobile, setMobile] = useState("");
  const [hide, setHide] = useState(true);
  const navigate = useNavigate();
  const [otp, setOtp] = useState(Array(4).fill(""));
    const handleOtpChange = (newOtp) => {
    setOtp(newOtp);
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="md">
      <Modal.Body className="d-flex flex-column align-items-center">
<div
        style={{
          display: "flex",
          width:"100%",
          justifyContent:"flex-end",
          padding: "1rem",
         
        }}
      >
        <Button
          variant="light"
          onClick={handleClose}
          style={{
            borderRadius: "50%",
            width: 40,
            height: 40,
            padding: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 22,
          }}
        >
          <FiX />
        </Button>
      </div>
       

        {/* Toggle Button */}
        {
            showotp ===  false &&
            <>
             <div style={{ position: "relative", marginTop: 20 }}>
          <img src={map} alt="Map" style={{ width: "100%" }} />
          <div
            style={{
              position: "absolute",
              height: 100,
              width: "100%",
              top: 170,
            }}
          >
            <h3 style={{ textAlign: "center", fontFamily: "Inter, sans-serif" }}>
              Get Started
            </h3>
            <p style={{ textAlign: "center", fontFamily: "Inter, sans-serif" }}>
              Sign in to access your account
            </p>
          </div>
        </div>
          <div
          style={{
            width: "80%",
            border: "1px solid #66D6FF",
            height: 50,
            borderRadius: 10,
            justifyContent: "space-between",
            display: "flex",
            padding: 5,
            marginTop: 20,
          }}>
          <button
            style={{
              width: "100%",
              borderRadius: 10,
              border: "none",
              fontFamily: "Inter, sans-serif",
              background: active === "SIGNIN" ? "#66D6FF" : "transparent",
              color: active === "SIGNIN" ? "#fff" : "#07448E",
            }}
            onClick={() => setActive("SIGNIN")}
          >
            SIGN IN / SIGN UP
          </button>
        </div>

        {/* SIGN IN */}
       
            <div style={{ width: "80%", marginTop: 20 }}>
              <p style={{ color: "#07448E" }}>Mobile Number</p>
              <div
                style={{
                  height: 50,
                  border: "1px solid #D8DADC",
                  borderRadius: 10,
                  padding: 5,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <input
                  placeholder="Your Mobile Number"
                  maxLength={10}
                  onChange={(e) => {
                    const onlyNums = e.target.value.replace(/[^0-9]/g, "");
                    if (onlyNums.length <= 10) setMobile(onlyNums);
                  }}
                  value={mobile}
                  style={{ width: "95%", border: "none", outline: "none" }}
                />
              </div>
            </div>

            <Button
              onClick={() => setShopOTP(true)}
              style={{
                width: "80%",
                marginTop: 20,
                height:50,
                backgroundColor: "#07448E",
                border: "none",
              }}
            >
              SEND OTP
            </Button>
            </>
        }
        

          {
            showotp ===  true &&
            <>
          
        {/* SIGN IN */}
       
             <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{display:"flex",justifyContent:"center",alignItems:"center",flexDirection:"column"}}>
        <img src={img} style={{ width: 160, height: 200 }} />
        <div style={{ width: "100%" }}>
          <h5
            style={{
              marginTop: 20,
              display: "flex",
              marginLeft: 10,
              color: "#323232",
              fontFamily: "Inter, sans-serif",
            }}
          >
            Verification Code
          </h5>
        </div>
        <p
          style={{
            padding: 10,
            color: "#B6B6B6",
            fontFamily: "Inter, sans-serif",
            marginTop: -7,
          }}
        >
          We have sent the verification code to your email address and phone
          number
        </p>

        <div style={{width:"90%",marginBottom:20}}>
           <span>+91 8569328589</span> <span style={{color:"#07448E"}} onClick={()=>setShopOTP(false)}><FiEdit3 size={20}/></span>
            </div>


        <OTPInputScreen length={4} onChange={handleOtpChange} />

        <button
          style={{
            height: 55,
            width: "95%",
            border: "none",
            background: "#07448E",
            borderRadius: 10,
            color: "#fff",
            fontFamily: "Inter, sans-serif",
            marginTop: 20,
          }}

          onClick={()=>navigate('/SuccessScreen')}
        >
          CONFIRM
        </button>
      </div>
    </div>
            </>
        }
        
       
       

        {/* SIGN UP */}
     

        {/* Other Sign-In Options */}
        <div style={{ marginTop: 20 }}>
          <p style={{ color: "#07448E", fontSize: 14 }}>Other Sign In Options</p>
        </div>

        <div className="d-flex gap-3 mb-4">
          {["facebook", "google", "apple"].map((platform, i) => (
            <div
              key={i}
              style={{
                width: 60,
                height: 60,
                border: "1px solid #D8DADC",
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={
                  platform === "facebook"
                    ? "https://cdn.creazilla.com/icons/7911211/facebook-icon-lg.png"
                    : platform === "google"
                    ? "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Google_%22G%22_logo.svg/1200px-Google_%22G%22_logo.svg.png"
                    : "https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg"
                }
                alt={platform}
                style={{ width: "50%", height: "50%" }}
              />
            </div>
          ))}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default LoginModal;
